import { useContext } from 'react';
import { DndContext } from 'react-dnd';

const useForBackend = (spec, fn, manager, backend) => {
  const previous = manager.getBackend();
  manager.receiveBackend(backend);
  const result = fn(spec);
  manager.receiveBackend(previous);
  return result;
};

export const useMultiCommon = (spec, fn) => {
  var _dndContext$dragDropM;

  const dndContext = useContext(DndContext);
  const dndBackend = dndContext === null || dndContext === void 0 ? void 0 : (_dndContext$dragDropM = dndContext.dragDropManager) === null || _dndContext$dragDropM === void 0 ? void 0 : _dndContext$dragDropM.getBackend();

  if (dndBackend === undefined) {
    throw new Error('could not find backend, make sure you are using a <DndProvider />');
  }

  const result = fn(spec);
  const multiResult = {};
  const backends = dndBackend.backendsList();

  for (const backend of backends) {
    multiResult[backend.id] = useForBackend(spec, fn, dndContext.dragDropManager, backend.instance);
  }

  return [result, multiResult];
};